import React from 'react';
import './testResult.scss';



export default function Stepper({ type, goBack, goNext, myTest }) {

    return (
        <div className=''>
            {
                window.innerWidth > 767 ?
                    <div className='stepper-header'>
                        {/* <img src='/images/back.svg' onClick={goBack} alt='' width={20} className='cursor-pointer' />&nbsp;&nbsp;
                        <div className='back'>
                            Back To<br /> {type === 'preview' ? 'Add Question' : type === 'add-question' ? 'Select tests' : 'Library'}
                        </div> */}
                        <div className="stepper-container">
                            <div className={type === 'test' ? "stepper-step active" : "stepper-step"}>
                                <span className="step-label">
                                    <button>1</button>&nbsp;
                                    &nbsp;Select Test
                                </span>
                            </div>
                            <img src='/images/double-arrow-right.svg' alt='' />
                            <div className={type === 'add-question' ? "stepper-step active" : "stepper-step"}>
                                <span className="step-label">
                                    <button>2</button>&nbsp;
                                    &nbsp;Add more questions
                                </span>
                            </div>
                            <img src='/images/double-arrow-right.svg' alt='' />
                            <div className={type === 'preview' ? "stepper-step active" : "stepper-step"}>
                                <span className="step-label">
                                    <button>3</button>&nbsp;
                                    &nbsp;Preview & Invite
                                </span>
                            </div>
                        </div>
                        {/* {type === 'preview' ? null : <div className='ms-5'>
                            <button className='next-btn' onClick={goNext}>Next</button>
                        </div>} */}
                    </div> :
                    <div className='gappeo-mobile-header1'>
                        <div className='selected-header d-flex justify-content-between'>
                            <div className='d-flex align-items-center'>
                                <img src='/images/back.svg' alt='' width={15} onClick={goBack} />&nbsp;&nbsp;
                                <div>
                                    <div className='d-flex align-items-center'>
                                        <div className={type === 'test' ? 'circle active' : 'circle'}></div>&nbsp;
                                        <div className={type === 'add-question' ? 'circle active' : 'circle'}></div>&nbsp;
                                        <div className={type === 'preview' ? 'circle active' : 'circle'}></div>
                                    </div>
                                    <h3 className='mt-2'>{type === 'test' ? 'Select Tests' : type === 'add-question' ? 'Add Question' : 'Preview & Invite'}</h3>
                                </div>
                            </div>
                            <button className='outline-btn' onClick={goNext}>Next</button>
                        </div>
                    </div>
            }
        </div>
    )
}
